export default state => state.vod.hodor.path;
